import React, {useState} from 'react';
import {T} from '../../../utils/I18n/I18n';
import EditName from './EditName';
import EditPassword from './EditPassword';

import './PersonalAreaEditPersonalData.scss';
import {Link} from "react-router-dom";

const PersonalAreaEditPersonalData = () => {
    const [isVisible, setIsVisible] = useState(false)

    const checkboxHandler = () => {
        setIsVisible(prevState => !prevState)
    }

    return (
        <>
            <span className="personal-area-title">{<T id="edit.header"/>}</span>
            <div className="personal-area-title__edit-user">
                <EditName/>
                <div className="personal-area-title__checkbox">
                    <input type="checkbox" onClick={checkboxHandler} />
                    <span><T id="edit.editPassword" /></span>
                </div>
                {isVisible && <EditPassword />}
            </div>
            <Link className="profile-form__link " to="/customer/account/">
                {<T id="edit.back" />}
            </Link>
        </>
    );
};

export default PersonalAreaEditPersonalData;
